import { ReportDataResponse } from '../../../types/reportData.interface';
import { FullPageModule } from '../../../styles/global.styles';
import { ReactComponent as PlaceholderImage } from '../../../assets/images/img-nophoto.svg';
import {
  AgentImage,
  AgentInfoContainer,
  AgentInfoContent,
  AgentData,
  AgentName,
  SecondaryInfo,
  Description,
  AgentContentRight,
} from './agentInfo.styles';

export const AgentInfo = (props: ReportDataResponse) => {
  return (
    <FullPageModule>
      <AgentInfoContainer>
        <AgentInfoContent>
          <AgentImage>
            {props.image ? (
              <img src={props.image} crossOrigin="anonymous" />
            ) : (
              <PlaceholderImage />
            )}
          </AgentImage>
          <AgentContentRight>
            <AgentData>
              <AgentName>{props.fullname}</AgentName>
              <SecondaryInfo>{props.phone}</SecondaryInfo>
              <SecondaryInfo>{props.email}</SecondaryInfo>
            </AgentData>
            <Description
              dangerouslySetInnerHTML={{ __html: props.description || '' }}
            />
          </AgentContentRight>
        </AgentInfoContent>
      </AgentInfoContainer>
    </FullPageModule>
  );
};
